import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './account-subscriptions.css'

const AccountSubscriptions = (props) => {
  return (
    <div className="account-subscriptions-container1">
      <Helmet>
        <title>Account-Subscriptions - Super Sizzling Curlew</title>
        <meta
          property="og:title"
          content="Account-Subscriptions - Super Sizzling Curlew"
        />
        <link
          rel="canonical"
          href="https://super-sizzling-curlew-lvmy3i.teleporthq.site/account-subscriptions"
        />
      </Helmet>
      <Navigation
        text={
          <Fragment>
            <span className="account-subscriptions-text10">More</span>
          </Fragment>
        }
      ></Navigation>
      <section className="account-access-hero">
        <div className="account-access-container">
          <div className="account-access-backdrop">
            <img
              src="https://images.pexels.com/photos/9159038/pexels-photo-9159038.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="SylliPlan AI Study Environment"
              className="account-access-bg-image"
            />
            <div className="account-access-overlay"></div>
          </div>
          <div className="account-access-modal-wrapper">
            <div className="account-access-modal">
              <div className="account-access-header">
                <h1 className="account---subscriptions-hero-title hero-title">
                  Welcome Back
                </h1>
                <p className="hero-subtitle">
                  Login to access your AI-powered semester plan and study tools.
                </p>
              </div>
              <form
                action="/login"
                method="POST"
                data-form-id="3a492f5a-ef00-4d00-ba08-c556bbb50001"
                className="account-access-form"
              >
                <div className="account-access-input-group">
                  <label htmlFor="email" className="section-content">
                    University Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required="true"
                    placeholder="name@university.edu"
                    data-form-field-id="email"
                    className="account-access-input"
                  />
                </div>
                <div className="account-access-input-group">
                  <div className="account-access-label-row">
                    <label htmlFor="password" className="section-content">
                      Password
                    </label>
                    <a href="#">
                      <div className="btn-sm btn-link">
                        <span>Forgot?</span>
                      </div>
                    </a>
                  </div>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    required="true"
                    placeholder="••••••••"
                    data-form-field-id="password"
                    className="account-access-input"
                  />
                </div>
                <button
                  type="submit"
                  id="thq_button_DXgF"
                  name="button"
                  data-form-field-id="thq_button_DXgF"
                  className="account-access-submit btn btn-primary btn-lg"
                >
                  Sign In
                </button>
              </form>
              <div className="account-access-divider">
                <span>OR</span>
              </div>
              <div className="account-access-social">
                <button className="account-access-social-btn btn btn-outline">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20.945 11a9 9 0 1 1-3.284-5.997l-2.655 2.392A5.5 5.5 0 1 0 17.125 14H13v-3z"></path>
                  </svg>
                  <span>
                    {' '}
                    Continue with Google
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                </button>
              </div>
              <div className="account-access-quick-links">
                <p className="section-content">Quick Access:</p>
                <div className="account-access-pills">
                  <a href="#subscriptions">
                    <div className="btn btn-secondary btn-sm">
                      <span>Subscriptions</span>
                    </div>
                  </a>
                  <a href="#billing">
                    <div className="btn btn-secondary btn-sm">
                      <span>Billing</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="subscriptions" className="subscription-plans">
        <div className="subscription-plans-container">
          <div className="subscription-plans-header">
            <h2 className="section-title">Choose Your Plan</h2>
            <p className="section-subtitle">
              Flexible options designed for every stage of your academic
              journey.
            </p>
          </div>
          <div className="subscription-plans-grid">
            <div className="subscription-card">
              <div className="subscription-card-header">
                <span className="subscription-badge">Basic</span>
                <h3 className="section-title">Free</h3>
                <div className="subscription-price">
                  <span className="price-symbol">$</span>
                  <span className="price-value">0</span>
                  <span className="account---subscriptions-price-period">
                    /mo
                  </span>
                </div>
              </div>
              <ul className="subscription-features">
                <li className="section-content">
                  <span>1 Syllabus Upload / Semester</span>
                </li>
                <li className="section-content">
                  <span>Basic Daily Task List</span>
                </li>
                <li className="section-content">
                  <span>AI Study Guide (3/mo)</span>
                </li>
                <li className="section-content">
                  <span>Standard Sync</span>
                </li>
              </ul>
              <button className="btn btn-lg btn-outline">Current Plan</button>
            </div>
            <div className="subscription-card featured">
              <div className="subscription-card-header">
                <span className="subscription-badge primary">Most Popular</span>
                <h3 className="section-title">Student</h3>
                <div className="subscription-price">
                  <span className="price-symbol">$</span>
                  <span className="price-value">9</span>
                  <span className="account---subscriptions-price-period">
                    /mo
                  </span>
                </div>
              </div>
              <ul className="subscription-features">
                <li className="section-content">
                  <span>Unlimited Syllabus Uploads</span>
                </li>
                <li className="section-content">
                  <span>Smart Calendar Integration</span>
                </li>
                <li className="section-content">
                  <span>AI Study Assistant (Unlimited)</span>
                </li>
                <li className="section-content">
                  <span>Priority Cloud Sync</span>
                </li>
              </ul>
              <button className="btn btn-primary btn-lg">Upgrade Now</button>
            </div>
            <div className="subscription-card">
              <div className="subscription-card-header">
                <span className="subscription-badge">Advanced</span>
                <h3 className="section-title">Premium</h3>
                <div className="subscription-price">
                  <span className="price-symbol">$</span>
                  <span className="price-value">19</span>
                  <span className="account---subscriptions-price-period">
                    /mo
                  </span>
                </div>
              </div>
              <ul className="subscription-features">
                <li className="section-content">
                  <span>Everything in Student</span>
                </li>
                <li className="section-content">
                  <span>Group Collaboration Tools</span>
                </li>
                <li className="section-content">
                  <span>Custom AI Tutoring Models</span>
                </li>
                <li className="section-content">
                  <span>Early Access to Features</span>
                </li>
              </ul>
              <button className="btn btn-lg btn-accent">Go Premium</button>
            </div>
          </div>
        </div>
      </section>
      <section id="billing" className="billing-management">
        <div className="billing-container">
          <div className="billing-header">
            <h2 className="section-title">Billing &amp; Payment</h2>
            <p className="section-subtitle">
              Manage your payment methods and view your transaction history.
            </p>
          </div>
          <div className="billing-tabs-wrapper">
            <div role="tablist" className="billing-tabs-nav">
              <button
                role="tab"
                aria-selected="true"
                data-tab="payment-methods"
                className="billing-tab-btn active"
              >
                Payment Methods
              </button>
              <button
                role="tab"
                aria-selected="false"
                data-tab="invoice-history"
                className="billing-tab-btn"
              >
                Invoice History
              </button>
              <button
                role="tab"
                aria-selected="false"
                data-tab="billing-info"
                className="billing-tab-btn"
              >
                Billing Info
              </button>
            </div>
            <div
              id="payment-methods"
              role="tabpanel"
              className="billing-tab-content active"
            >
              <div className="billing-card-list">
                <div className="billing-method-item">
                  <div className="billing-method-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                      <path d="M2 10h20"></path>
                    </svg>
                  </div>
                  <div className="billing-method-details">
                    <p className="section-content">Visa ending in 4242</p>
                    <p className="opacity-70 section-content">Expires 12/26</p>
                  </div>
                  <span className="billing-badge">Default</span>
                  <button className="btn btn-sm btn-link">Edit</button>
                </div>
                <button className="btn-md add-method-btn btn btn-outline">
                  Add New Method
                </button>
              </div>
            </div>
            <div
              id="invoice-history"
              role="tabpanel"
              className="billing-tab-content"
            >
              <div className="billing-history-table">
                <div className="history-row header">
                  <span>Date</span>
                  <span>Amount</span>
                  <span>Status</span>
                  <span>Action</span>
                </div>
                <div className="history-row">
                  <span>Oct 12, 2023</span>
                  <span>$9.00</span>
                  <span className="status-paid">Paid</span>
                  <button className="btn btn-sm btn-link">PDF</button>
                </div>
                <div className="history-row">
                  <span>Sep 12, 2023</span>
                  <span>$9.00</span>
                  <span className="status-paid">Paid</span>
                  <button className="btn btn-sm btn-link">PDF</button>
                </div>
              </div>
            </div>
            <div
              id="billing-info"
              role="tabpanel"
              className="billing-tab-content"
            >
              <div className="billing-details-summary">
                <div className="summary-item">
                  <p className="font-bold section-content">Next Billing Date</p>
                  <p className="section-content">November 12, 2023</p>
                </div>
                <div className="summary-item">
                  <p className="font-bold section-content">Billing Email</p>
                  <p className="section-content">alex.student@university.edu</p>
                </div>
                <button className="btn btn-secondary">Update Details</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="plan-process">
        <div className="plan-process-container">
          <div className="plan-process-header">
            <h2 className="section-title">Modify Your Subscription</h2>
            <p className="section-subtitle">
              Step-by-step process for upgrading, downgrading, pausing, or
              canceling.
            </p>
          </div>
          <div className="plan-steps-vertical">
            <div className="plan-step">
              <div className="account---subscriptions-step-number">
                <span>1</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Select New Plan</h3>
                <p className="section-content">
                  Choose the plan that best fits your current workload. Upgrades
                  take effect immediately with prorated charges.
                </p>
              </div>
            </div>
            <div className="plan-step">
              <div className="account---subscriptions-step-number">
                <span>2</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">
                  Review Prorating &amp; Refunds
                </h3>
                <p className="section-content">
                  When downgrading or canceling, your current benefits remain
                  active until the end of the billing cycle. No partial refunds
                  are issued.
                </p>
              </div>
            </div>
            <div className="plan-step">
              <div className="account---subscriptions-step-number">
                <span>3</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Confirm Changes</h3>
                <p className="section-content">
                  Confirm your selection. You will receive an email verification
                  once the modification is processed in our system.
                </p>
              </div>
            </div>
            <div className="plan-step">
              <div className="account---subscriptions-step-number">
                <span>4</span>
              </div>
              <div className="step-content">
                <h3 className="section-subtitle">Sync Your Schedule</h3>
                <p className="section-content">
                  Your new features, including advanced AI tools or unlimited
                  uploads, will sync across all your connected devices
                  instantly.
                </p>
              </div>
            </div>
          </div>
          <div className="plan-process-actions">
            <button className="btn btn-primary btn-lg">
              Modify Subscription
            </button>
            <button className="btn btn-link">Pause Subscription</button>
          </div>
        </div>
      </section>
      <section className="account-settings">
        <div className="settings-container">
          <div className="settings-header">
            <h2 className="section-title">Account Settings</h2>
            <p className="section-subtitle">
              Manage profile, notification preferences, and syllabus sync
              settings.
            </p>
          </div>
          <div className="settings-tabs-wrapper">
            <div role="tablist" className="settings-tabs-nav">
              <button
                role="tab"
                data-tab="profile"
                className="settings-tab-btn active"
              >
                Profile
              </button>
              <button
                role="tab"
                data-tab="notifications"
                className="settings-tab-btn"
              >
                Notifications
              </button>
              <button role="tab" data-tab="sync" className="settings-tab-btn">
                Syllabus Sync
              </button>
            </div>
            <div id="profile" className="settings-tab-content active">
              <div className="profile-grid">
                <div className="profile-avatar-section">
                  <div className="avatar-placeholder">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48"
                      height="48"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </div>
                  <button className="btn btn-outline btn-sm">
                    Change Photo
                  </button>
                </div>
                <div className="profile-form-grid">
                  <div className="input-group">
                    <label className="section-content">Display Name</label>
                    <input
                      type="text"
                      value="Alex Student"
                      className="settings-input"
                    />
                  </div>
                  <div className="input-group">
                    <label className="section-content">Major</label>
                    <input
                      type="text"
                      value="Computer Science"
                      className="settings-input"
                    />
                  </div>
                  <button className="btn btn-primary">Save Profile</button>
                </div>
              </div>
            </div>
            <div id="notifications" className="settings-tab-content">
              <div className="notification-list">
                <div className="notif-item">
                  <div className="notif-text">
                    <p className="font-bold section-content">
                      Assignment Reminders
                    </p>
                    <p className="opacity-70 section-content">
                      Get alerts before deadlines
                    </p>
                  </div>
                  <input
                    type="checkbox"
                    checked="true"
                    className="settings-toggle"
                  />
                </div>
                <div className="notif-item">
                  <div className="notif-text">
                    <p className="font-bold section-content">
                      Daily Study Plan
                    </p>
                    <p className="opacity-70 section-content">
                      Morning digest of your tasks
                    </p>
                  </div>
                  <input
                    type="checkbox"
                    checked="true"
                    className="settings-toggle"
                  />
                </div>
              </div>
            </div>
            <div id="sync" className="settings-tab-content">
              <div className="sync-settings">
                <p className="section-content">
                  Configure how your syllabus data is synchronized with external
                  calendars.
                </p>
                <div className="sync-options">
                  <div className="sync-card">
                    <p className="font-bold section-content">Google Calendar</p>
                    <button className="btn btn-secondary btn-sm">
                      Connected
                    </button>
                  </div>
                  <div className="sync-card">
                    <p className="font-bold section-content">
                      Outlook Calendar
                    </p>
                    <button className="btn btn-outline btn-sm">Connect</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="security-privacy">
        <div className="security-container">
          <div className="security-header">
            <h2 className="section-title">Security &amp; Privacy</h2>
            <p className="section-subtitle">
              How your syllabus and study data are stored and protected.
            </p>
          </div>
          <div className="security-grid">
            <div className="security-item">
              <div className="security-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">End-to-End Encryption</h3>
              <p className="section-content">
                All uploaded syllabi are encrypted at rest and in transit using
                industry-standard protocols.
              </p>
            </div>
            <div className="security-item">
              <div className="security-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M12 16v-4"></path>
                  <path d="M12 8h.01"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Data Privacy</h3>
              <p className="section-content">
                We never sell your academic data to third parties. Your study
                habits remain strictly confidential.
              </p>
            </div>
            <div className="security-item">
              <div className="security-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">AI Protection</h3>
              <p className="section-content">
                Our AI study tools are sandboxed to ensure no personal
                information leaks into training models.
              </p>
            </div>
            <div className="security-item">
              <div className="security-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect
                    width="18"
                    height="11"
                    x="3"
                    y="11"
                    rx="2"
                    ry="2"
                  ></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Two-Factor Auth</h3>
              <p className="section-content">
                Add an extra layer of security to your account with mandatory
                2FA for all premium users.
              </p>
            </div>
            <div className="security-item">
              <div className="security-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
              </div>
              <h3 className="section-subtitle">Policy Access</h3>
              <p className="section-content">
                Easily review our Terms of Service and Privacy Policy anytime
                from your settings dashboard.
              </p>
            </div>
            <div className="security-item">
              <div className="security-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" x2="12" y1="15" y2="3"></line>
                </svg>
              </div>
              <h3 className="section-subtitle">Data Portability</h3>
              <p className="section-content">
                Export your semester plans and assignment data in CSV or PDF
                format at any time.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="support-contact">
        <div className="support-container">
          <div className="support-header">
            <h2 className="section-title">Support &amp; Contact</h2>
            <p className="section-subtitle">
              Quick access to billing support and account help.
            </p>
          </div>
          <div className="support-grid">
            <div className="support-card">
              <div className="support-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Help Center</h3>
              <p className="section-content">
                Browse FAQs and detailed guides on syllabus uploading and AI
                tools.
              </p>
              <button className="btn btn-link">Visit FAQs</button>
            </div>
            <div className="support-card">
              <div className="support-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Live Chat</h3>
              <p className="section-content">
                Connect with our support team instantly for real-time
                assistance.
              </p>
              <button className="btn btn-link">Start Chat</button>
            </div>
            <div className="support-card">
              <div className="support-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Email Support</h3>
              <p className="section-content">
                Send us a detailed inquiry and we&apos;ll get back to you within
                24 hours.
              </p>
              <button className="btn btn-link">Send Email</button>
            </div>
            <div className="support-card">
              <div className="support-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">System Status</h3>
              <p className="section-content">
                Check the current operational status of SylliPlan AI and
                servers.
              </p>
              <button className="btn btn-link">Check Status</button>
            </div>
          </div>
        </div>
      </section>
      <div className="account-subscriptions-container2">
        <div className="account-subscriptions-container3">
          <Script
            html={`<style>
section {
  padding: var(--spacing-4xl) 0;
  position: relative;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="account-subscriptions-container4">
        <div className="account-subscriptions-container5">
          <Script
            html={`<script defer data-name="sylliplan-tabs">
(function(){
  // Tab Controller for Billing and Settings Sections
  function initTabs() {
    const tabContainers = [
      { nav: ".billing-tabs-nav", content: ".billing-tab-content" },
      { nav: ".settings-tabs-nav", content: ".settings-tab-content" },
    ]

    tabContainers.forEach((container) => {
      const nav = document.querySelector(container.nav)
      if (!nav) return

      const btns = nav.querySelectorAll("button")
      const contents = nav.parentElement.querySelectorAll(container.content)

      btns.forEach((btn) => {
        btn.addEventListener("click", () => {
          const targetId = btn.getAttribute("data-tab")

          // Remove active states
          btns.forEach((b) => {
            b.classList.remove("active")
            b.setAttribute("aria-selected", "false")
          })
          contents.forEach((c) => c.classList.remove("active"))

          // Add active states
          btn.classList.add("active")
          btn.setAttribute("aria-selected", "true")
          const targetContent = document.getElementById(targetId)
          if (targetContent) targetContent.classList.add("active")
        })
      })
    })
  }

  // Simple Form Validation Feedback (Visual Only)
  function initFormFeedback() {
    const forms = document.querySelectorAll("form")
    forms.forEach((form) => {
      form.addEventListener("submit", (e) => {
        const submitBtn = form.querySelector('button[type="submit"]')
        if (form.checkValidity()) {
          submitBtn.innerHTML = "Processing..."
          submitBtn.style.opacity = "0.7"
        }
      })

      const inputs = form.querySelectorAll("input")
      inputs.forEach((input) => {
        input.addEventListener("blur", () => {
          if (!input.checkValidity()) {
            input.style.borderColor = "#e74c3c"
          } else {
            input.style.borderColor = "var(--color-outline)"
          }
        })
      })
    })
  }

  // Scroll Reveal Effect (Medium Animation Level)
  function initScrollReveal() {
    const items = document.querySelectorAll(".subscription-card, .security-item, .support-card, .plan-step")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1"
            entry.target.style.transform = "translateY(0)"
          }
        })
      },
      { threshold: 0.1 }
    )

    items.forEach((item) => {
      item.style.opacity = "0"
      item.style.transform = "translateY(20px)"
      item.style.transition = "all 0.6s ease-out"
      observer.observe(item)
    })
  }

  // Execute initializations
  initTabs()
  initFormFeedback()
  initScrollReveal()
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default AccountSubscriptions
